import type { FC } from 'react';

import { ExperimentChatProvider } from '@apps/chatv2-shared-multilabel';
import type { AppProps } from '@eneco/next';

const EXPERIMENT_NAME = 'eneco-chatbot-v2';

const GrootzakelijkApp: FC<AppProps> = ({ Component, pageProps: { featureVariants, ...pageProps } }) => {
  const isEnecoChatEnabled = featureVariants?.[EXPERIMENT_NAME] ?? true;

  return (
    <ExperimentChatProvider isEnabled={isEnecoChatEnabled} defaultNamespace="eneco-nl-b2c" authenticated={false}>
      <Component {...pageProps} />
    </ExperimentChatProvider>
  );
};

export default GrootzakelijkApp;
